<div class="dashboard container-fluid d-flex flex-column m-2 mt-5">
  <div class="dashboard_header row w-100">
    <div class="col-4">
      <app-speedomater [rate]="rate"></app-speedomater>
    </div>
    <div class="col-8">
      <app-contact-expert [contactExpertData]="contactExpertData" (contactExpertReqEmit)="contactExpertReq()"></app-contact-expert>
    </div>
  </div>
  <div class="dashboard_list mt-4 row w-100 align-items-stretch">
    <div *ngFor="let infoCard of infoCards" class="col-4 align-items-stretch mb-4">
      <app-info-card class="d-flex align-items-stretch h-100" [infoCard]="infoCard" (handlerInfoCardEmit)="handlerInfoCard($event)" ></app-info-card>
    </div>
  </div>
</div>

